/* Qalbeen · HOVER : blog (filtre par thème sans recharger) et article (barre de lecture, barre mobile refermable,
   partage, arabe lisible). Sans jQuery, chargé en defer. Fonctionne aussi quand l'éditeur recharge une section. */
(function () {
  if (window.HoverBlog) return;
  var D = document;
  var $$ = function (s, c) { return Array.prototype.slice.call((c || D).querySelectorAll(s)); };
  var editeur = !!(window.Shopify && Shopify.designMode);

  /* ---------- blog : puces de thème ---------- */
  function puces(c) {
    $$('[data-hvb-chips]', c).forEach(function (box) {
      if (box._hvb) return; box._hvb = 1;
      var sec = box.closest('.hvb-blog'); if (!sec) return;
      var vide = sec.querySelector('[data-hvb-empty]');
      box.addEventListener('click', function (e) {
        var b = e.target.closest('.hv-chip'); if (!b) return;
        $$('.hv-chip', box).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
        var k = b.getAttribute('data-k') || '', n = 0;
        sec.classList.toggle('hvb-filtering', !!k);
        $$('.hvb-post', sec.querySelector('[data-hvb-posts]')).forEach(function (p) {
          var ok = !k || (p.getAttribute('data-hvb-cats') || '').indexOf(k) > -1;
          p.classList.toggle('hvb-hide', !ok);
          if (ok && (k || !p.classList.contains('is-feat'))) { n++; p.classList.add('vu'); }
        });
        if (vide) vide.hidden = n > 0;
      });
    });
  }

  /* ---------- article ---------- */
  function lireArabe(c) {
    var ar = /[؀-ۿ]/g, lat = /[A-Za-zÀ-ÿ]/g;
    $$('[data-hvb-prose] p', c).forEach(function (p) {
      var t = p.textContent || '', a = (t.match(ar) || []).length, l = (t.match(lat) || []).length;
      if (a > 20 && a > l * 3) { p.classList.add('hvb-ar'); p.setAttribute('dir', 'rtl'); p.setAttribute('lang', 'ar'); }
    });
  }

  function partage(c) {
    $$('[data-hvb-share]', c).forEach(function (box) {
      if (box._hvb) return; box._hvb = 1;
      var nat = box.querySelector('[data-hvb-native]');
      if (nat && navigator.share) {
        nat.hidden = false;
        nat.addEventListener('click', function () {
          navigator.share({ title: nat.getAttribute('data-title'), url: nat.getAttribute('data-url') }).catch(function () {});
        });
      }
      var cp = box.querySelector('[data-hvb-copy]');
      if (cp) cp.addEventListener('click', function () {
        var url = cp.getAttribute('data-hvb-copy'), avant = cp.textContent;
        var fini = function () { cp.textContent = cp.getAttribute('data-done') || avant; setTimeout(function () { cp.textContent = avant; }, 2200); };
        if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(url).then(fini, fini);
        else { try { var i = D.createElement('input'); i.value = url; D.body.appendChild(i); i.select(); D.execCommand('copy'); i.remove(); } catch (_) {} fini(); }
      });
    });
  }

  var art = null, prog = null, st = null, seuil = 0.4, ferme = false, tic = false;
  try { ferme = sessionStorage.getItem('hvb-st-off') === '1'; } catch (_) {}

  function mesure() {
    tic = false;
    if (!art || !art.isConnected) return;
    var r = art.getBoundingClientRect(), h = window.innerHeight;
    var p = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height - h * 0.6)));
    if (prog) prog.style.setProperty('--p', p.toFixed(4));
    if (st) {
      var v = !ferme && !editeur && p >= seuil && r.bottom > h * 0.6 && window.innerWidth < 1000;
      if (st.classList.contains('on') !== v) {
        st.classList.toggle('on', v); st.setAttribute('aria-hidden', String(!v)); st.inert = !v;
        D.body.classList.toggle('hv-has-sticky', v);
      }
    }
  }
  function onScroll() { if (!tic) { tic = true; requestAnimationFrame(mesure); } }

  function article(c) {
    var a = (c || D).querySelector ? (c || D).querySelector('[data-hvb-article]') : null;
    if (!a && c && c.matches && c.matches('[data-hvb-article]')) a = c;
    if (!a) return;
    art = a.querySelector('[data-hvb-prose]') || a;
    prog = D.querySelector('[data-hvb-prog]');
    st = D.querySelector('[data-hvb-st]');
    seuil = (parseFloat(a.getAttribute('data-hvb-sticky-at')) || 40) / 100;
    if (st && !st._hvb) {
      st._hvb = 1;
      var x = st.querySelector('[data-hvb-st-close]');
      if (x) x.addEventListener('click', function () {
        ferme = true; try { sessionStorage.setItem('hvb-st-off', '1'); } catch (_) {}
        st.classList.remove('on'); st.setAttribute('aria-hidden', 'true'); st.inert = true; D.body.classList.remove('hv-has-sticky');
      });
    }
    lireArabe(a); partage(a); mesure();
  }

  function init(c) { puces(c); article(c); }
  window.HoverBlog = { init: init };
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll, { passive: true });
  init(D);
  D.addEventListener('shopify:section:load', function (e) { init(D); });
})();
